var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"maps"},[_c('span',{staticClass:"title"},[_vm._v("地图导航")]),_c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.name}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }